package one.healthium.log_food.ui.navigation.find_food

import com.arkivanov.decompose.ComponentContext
import one.healthium.profile.ui.food.models.FoodUiModel

class DefaultFindFoodComponent(
    componentContext: ComponentContext,
    private val onFoodClicked: (FoodUiModel) -> Unit,
    private val onScanBarcode: suspend () -> String?,
    private val onScanFood: suspend () -> List<FoodUiModel>?,
    private val onFoodsScanned: (List<FoodUiModel>) -> Unit,
) : FindFoodComponent, ComponentContext by componentContext {
    override fun onFoodClicked(food: FoodUiModel) {
        onFoodClicked.invoke(food)
    }

    override suspend fun onScanBarcode(): String? {
        return onScanBarcode.invoke()
    }

    override suspend fun onScanFood(): List<FoodUiModel>? {
        return onScanFood.invoke()
    }

    override fun onFoodsScanned(foods: List<FoodUiModel>) {
        onFoodsScanned.invoke(foods)
    }
}
